import { memo } from 'react';
import MovingPlaceholder from 'pages/AutomationEngine/Engine/Steps/moving-placeholder/MovingPlaceholder';
import { StepCardOld } from 'pages/AutomationEngine/Engine/Steps/StepCardOld';
import * as cardTypes from '__pages/AutomationEngine/Engine/Steps/type';
import steps, { type SmartStepType } from '../steps';

type ErrorStepCardProps = {
  step: { type: SmartStepType };
  type: any;
  showStats: boolean;
  showHandle: boolean | undefined;
  showMenu: boolean | undefined;
  onSelectMenu: any;
  disableMenu: boolean;
  scale: number;
  onStart: any;
  onStop: any;
  showMovingPlaceholder: boolean;
};

function ErrorStepCard({
  type,
  step,
  showStats,
  disableMenu,
  scale,
  onStart,
  onStop,
  showMovingPlaceholder = false,
  ...others
}: ErrorStepCardProps) {
  const stepType = step.type;

  const stepConfig = steps[stepType];

  const CardComponent =
    (showMovingPlaceholder && MovingPlaceholder) ||
    cardTypes[stepConfig.CardComponent as unknown as string] ||
    StepCardOld;

  return (
    <CardComponent
      title={stepConfig.title}
      color="var(--color-button-warning-hover)"
      borderColor="var(--color-button-warning-hover)"
      panel={null}
      menuOptions={[
        stepConfig.deletable && { label: 'Delete', value: 'delete' },
      ].filter(Boolean)}
      disableMenu={
        disableMenu || (!stepConfig.creatable && !stepConfig.deletable)
      }
      {...(stepConfig.CardComponent && { type, step })}
      {...(stepConfig.movable && {
        scale,
        onStart,
        onStop,
      })}
      {...others}
      isSmartConnectorFlow
    />
  );
}

export default memo(ErrorStepCard);
